import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { CANADA_COUNTRY_ID, Country, State, USA_COUNTRY_ID } from '@app/models/country.model';
import { OrderTemplate } from '@feature/orders/shared';

@Injectable({ providedIn: 'root' })
export class CountryService {

	constructor(private http: HttpClient) { }

	public getCountries(): Observable<Array<Country>> {
		return this.http.get<Array<Country>>(`${environment.config.apiUrl}/countries`);
	}

	public getOperationalCountries(): Observable<Array<Country>> {
		return this.http.get<Array<Country>>(`${environment.config.apiUrl}/countries-operational`);
	}

	public getStripeCountries(): Observable<Country[]> {
		return this.http.get<Country[]>(`${environment.config.apiUrl}/countries-stripe`);
	}

	public getStates(countryId: number): Observable<Array<State>> {
		return this.http.get<Array<State>>(`${environment.config.apiUrl}/countries/${countryId}/states`);
	}

	public getState(stateId: number): Observable<State> {
		return this.http.get<State>(`${environment.config.apiUrl}/states/${stateId}`);
	}

	public getOrderTemplates(countryId: number, skipNonUnion: boolean = true): Observable<Array<OrderTemplate>> {
		let parameters: HttpParams = new HttpParams();
		parameters = parameters.append('skipNonUnion', skipNonUnion);
		return this.http.get<Array<OrderTemplate>>(`${environment.config.apiUrl}/countries/${countryId}/order-templates`, { params: parameters });
	}

	/**
	 * Matches the given country id with a desired country id.
	 *
	 * @param {number | string} sourceCountry
	 * @param {number} matchCountry
	 * @returns {boolean}
	 */
	static checkCountryId(sourceCountry: number | string, matchCountry: number): boolean {
		return sourceCountry && parseInt(sourceCountry.toString(), 10) === matchCountry;
	}
}
